/**
 * @author: Armando Jr. 26/06/2020
 * @description: Shows Time Picker to select a **ABSOLUTE** time, by default to **mm:ss**.
 *               You can change the default format to **HH:mm:ss** or **mm:ss**
 *               In afterCreateForm, call field.setCustomFormat passing the one of the formats above.
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeMinutesSecondsField = (function () {

    function TimeMinutesSecondsField () {

        Monet.UI.Fields.TimeField.apply(this, arguments);

        this.getValue = function () {
            if(this.input.value === "") {
                return "";
            }
            var seconds = new Monet.Format.SECONDS(this.input.value)
                            .convertHourToSeconds()
                            .getValue();
            
            return seconds;
        };

        this.setValue = function (value) {
            if (value) {
                const formatSeconds = new Monet.Format.SECONDS(value);
                const format = this.getFormat();

                if(format === "HH:mm") {
                    formatSeconds.convertSecondsToHourMinutes();
                } else {
                    formatSeconds.convertSecondsToHourMinutesSeconds();
                }

                this.value = formatSeconds.getValue();
                this.setInputValue();
            }
        };

        this.setInputValue = function() {
            if (this.input && this.value) {
                this.input.value = this.value;
            }
        };

        this.initializeSpecialBehavior = function() {
            const format = this.getFormat();
            new Monet.Date.GeneralFunctions().setTimePicker(this.input, null, (format));
        };

        this.getFormat = () => {
            const metaFormat = this.getMeta();
            return metaFormat?.format && metaFormat.format === "HH:mm" ? "HH:mm" : "HH:mm:ss";
        };
    }

    return TimeMinutesSecondsField;

}());
